import { render, staticRenderFns } from "./addOptionManage.vue?vue&type=template&id=11a8c48c&scoped=true&"
import script from "./addOptionManage.vue?vue&type=script&lang=js&"
export * from "./addOptionManage.vue?vue&type=script&lang=js&"
import style0 from "./addOptionManage.vue?vue&type=style&index=0&id=11a8c48c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a8c48c",
  null
  
)

export default component.exports